import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { HeroChicago } from "@/components/site/HeroChicago";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";
import { WhyChooseChicago } from "@/components/site/WhyChooseChicago";
import { safeJsonLd } from "@/lib/structured-data";
import { getSanDiegoStructuredData } from "@/lib/structured-data/san-diego";
import { CITY_FAQS } from "@/content/wp-parity/faqs/city";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const LocationsMapSanDiego = lazy(() => import("@/components/site/LocationsMapSanDiego").then(m => ({ default: m.LocationsMapSanDiego })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/locations/california/san-diego")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | San Diego Hair Transplants + Hair Restoration" },
      { name: "description", content: "Get your hair back and RESTORE your confidence in San Diego, CA with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult!" },
      { property: "og:title", content: "Get Your Hair Back | RESTORE® Hair Transplants — San Diego" },
      { property: "og:description", content: "Top hair restoration team serving San Diego. Soft, natural, undetectable results." },
      { property: "og:url", content: "https://restorehair.com/locations/california/san-diego/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/california/san-diego/" }],
    scripts: [{ type: "application/ld+json", children: safeJsonLd({ "@graph": getSanDiegoStructuredData() }) }],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <HeroChicago
          h1="San Diego Hair Transplants"
          eyebrow="RESTORE® | San Diego Hair Transplants"
          subheading="RESTORE your confidence with the #1 hair restoration team serving San Diego"
          extraParagraph="Find out about your hair transplant options in San Diego."
        />
        <NorwoodQuiz />
        <WhyChooseChicago />
        <Suspense fallback={null}>
          <div className="hidden md:block"><Results /></div>
          <ValueProps hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy dougLeft />
          <Reviews />
          <Guarantee />
          <Pricing city="San Diego" />
          <VirtualConsult />
          <Surgeons
            eyebrow="RESTORE San Diego Hair Transplant Doctors"
            heading={<>A World Renowned <span className="text-foreground">Team</span></>}
          />
          <DoctorsGrid />
          <LocationsMapSanDiego />
          <Faq items={CITY_FAQS} />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}